module.exports = __webpack_public_path__ + "static/media/instagram.c73d5c9e.svg";